import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-16 px-4 overflow-hidden" data-id="element-81">
      {/* Background Effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#00d4ff]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-82"></div>

      <div className="max-w-5xl mx-auto w-full flex flex-col items-center text-center z-10" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="w-full" data-id="element-84">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-playfair leading-tight mb-6" data-id="element-85">
            Detén el secuestro de tu cerebro por el azúcar en solo{' '}
            <span className="text-[#00d4ff] text-glow-cyan" data-id="element-86">72 horas</span>
            <br data-id="element-87" />
            <span className="text-2xl md:text-3xl lg:text-4xl text-[#f5a623] font-normal italic mt-2 block" data-id="element-88">
              (sin usar fuerza de voluntad)
            </span>
          </h1>

          <p className="text-lg md:text-xl text-[#a0a0b0] max-w-3xl mx-auto mb-10 leading-relaxed font-inter" data-id="element-89">
            El protocolo biológico de 3 días diseñado para mujeres agotadas que
            quieren apagar los antojos nocturnos y desinflamar su cuerpo de
            forma inmediata.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-2xl mx-auto mb-12" data-id="element-90">
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0f] via-transparent to-transparent z-10" data-id="element-91"></div>
          <div className="absolute -inset-4 bg-[#00d4ff]/20 blur-2xl rounded-full z-0" data-id="element-92"></div>
          <img src="https://cdn.magicpatterns.com/uploads/gerDuCv8MBAqVKN592Cger/heylloyd-image-1773970445727.png" alt="Protocolo Adiós Azúcar" className="relative z-0 w-full h-auto rounded-xl shadow-2xl border border-[#00d4ff]/20 transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-93" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-94">
          <CTAButton className="w-full md:w-auto text-xl py-5 px-10" data-id="element-95">
            ¡QUIERO DETENER MIS ANTOJOS AHORA!
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}